import {MutationTree} from "vuex";
import * as moment from "moment";

export const mutations: MutationTree<any> = {

    setData(state: any, payload: Array<any>) {
        state.healthMetrics = payload;
        state.healthMetricsExpires = moment().add(240, 'minutes');
    },

    setActivityByWeekData(state: any, payload: Array<any>) {
        state.activityByWeek = payload;
    },

    setLoading(state: any, payload: Boolean) {
        state.loading = payload;
    },

    setCreatedAt(state: any, payload: Array<any>) {
        state.createdAt = payload;
    },

    updatePeriod(state: any, payload: number) {
        state.selectedPeriod = payload;
    },

    clearHealthCache(state:any) {
        state.healthMetricsExpires = null;
    }
};
